<template>
	<FeatureDescriptionPreviewTemplate iconName="feature-description-details-page">
		<template #description>
			On the the feature details page, which is visible to the users through their feature list under “create and manage”
		</template>
		<template #floating-card>
			<Col class="preview-container">
				<Col class="preview-text mt-1 six-row">{{ onboardingText }}</Col>
			</Col>
		</template>
	</FeatureDescriptionPreviewTemplate>
</template>
<script>
import FeatureDescriptionPreviewTemplate from '@/components/dialogs/OnboardingTextEditorDialog/FeatureDescriptionPreview/FeatureDescriptionPreviewTemplate.vue';
export default {
	name: 'FeatureDescriptionDetailsPage',
	components: { FeatureDescriptionPreviewTemplate },
	props: {
		onboardingText: { type: String },
	},
};
</script>
<style scoped lang="scss">
.preview-text {
	font-size: 10px;
	line-height: 12px;
	letter-spacing: 0px;
	font-weight: normal;
	color: var(--primary-font-color);
}
.six-row {
	overflow: hidden;
	display: -webkit-box;
	text-overflow: ellipsis;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 6; // num of rows to break
}
.preview-container {
	left: 44px;
	bottom: 92px;
	width: 238px;
	height: 83px;
	padding: 4px 10px;
	position: absolute;
	border-radius: 12px;
}
</style>
